import React from "react";
import Modal from "react-bootstrap/Modal";
import circle from "../../Components/assets/icons/circle.png";
import "./ModelSave.css";

const ModalSave = (props) => {
  return (
    <Modal
      show={props.showErrorModal}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-save-premium-dialog"
      contentClassName="modal-save-premium"
    >
      <Modal.Body>
        <div className="modal-save-premium-icon">
          <img src={circle} alt="Success" />
        </div>

        <h1 className="modal-save-premium-title">{props.message}</h1>

        <p className="modal-save-premium-description">
          Your request has been completed successfully.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default ModalSave;
